import React, { useState, useEffect } from "react";
import Header from "../../components/header";
import styles from "./PresupuestosPlanificacion.module.css";
import History from "../../components/history";
import { Button, Form, Table, Row, Col } from "react-bootstrap";
import { useCookies } from 'react-cookie';
import { checkSession, isMobile } from "../../core/session";
import TimeFilter from "../../components/time-filter"
import ModificarLineaModal from "./ModificarLineaModal/ModificarLineaModal";
import ModificarInversionModal from "./ModificarInversionModal";
import axios from "axios";
import { set } from "local-storage";

const PresupuestosPlanificacion = (props) => {

    const loadingBtn = require("../../assets/loaders/btn-loading.gif");

    const [cookie, setCookies, removeCookie] = useCookies(['kUserSession']);
    const [showModal, setShowModal] = useState(false);

    function calcularTotalesPorFila(data) {
        return data.map(fila => {
            const total = fila.valores.reduce((sum, valor) => { return sum + (valor.importe ?? 0); }, 0);
            return { ...fila, total };
        });
    }

    const [expenses, setExpenses] = useState([]);
    const [inversiones, setInversiones] = useState([]);

    const [loading, setLoading] = useState(false);
    const [inversionesLoading, setInversionesLoading] = useState(false);    

    const [editingIndex, setEditingIndex] = useState(null);
    const [formState, setFormState] = useState({});

    const [showModalInversiones, setShowModalInversiones] = useState(false);
    const [editingIndexInversiones, setEditingIndexInversiones] = useState(null);
    const [formStateInversiones, setFormStateInversiones] = useState({});    

    const getTotalPorMes = (mes) => expenses.reduce((acc, item) => acc + (item.valores[mes].importe ?? 0), 0);
    const getTotalInversionesPorMes = (mes) => inversiones.reduce((acc, item) => acc + item.valores[mes].importe ?? 0, 0);

    const [year, setYear] = useState(new Date().getFullYear());

    const history = [
        {
            name: "Inicio",
            path: "/"
        },
        {
            name: "Presupuestos",
            path: "/presupuestos"
        }
    ]

    const prepareHeaders = () => {
        return {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "api_key": "k-randa",
                "access_token": cookie.kUserSession.data.access_token
            }
        };
    }

    const getPresupuestos = () => {       
        setLoading(true);
        const { id:idEstancia } = cookie.kUserSession.data["farm"];
        axios.get(process.env.REACT_APP_API_URL + `presupuestos?estancia=${idEstancia}&periodo=${year}&tipo=PRESUPUESTO`, prepareHeaders()).
        then(rs => {
            console.log(rs.data);
            setExpenses(calcularTotalesPorFila(rs.data))
            setLoading(false);
        }).
        catch(err => {
           console.log(err);
           setExpenses([]);
           setLoading(false);
        });
    };

    const getInversiones = () => {
        setInversionesLoading(true);
        const { id:idEstancia } = cookie.kUserSession.data["farm"];
        axios.get(process.env.REACT_APP_API_URL + `presupuestos?estancia=${idEstancia}&periodo=${year}&tipo=INVERSION`, prepareHeaders()).
        then(rs => {
            console.log(rs.data);
            setInversiones(calcularTotalesPorFila(rs.data));
            setInversionesLoading(false);
        }).
        catch(err => {
            console.log(err);
            setInversiones([]);
            setInversionesLoading(false);
        });
    };
    

    const abrirModalInversinoes = (item, index) => {
        setEditingIndexInversiones(index);
        setFormStateInversiones({ ...item });
        setShowModalInversiones(true);
    };

    const guardarCambiosInversiones = (nuevoTotal) => {
        const nuevasInversiones = [...inversiones];

        nuevasInversiones[editingIndexInversiones] = {
            ...formStateInversiones,
            total: nuevoTotal
        };

        let current = nuevasInversiones[editingIndexInversiones];

        let presupuestos = [];
        for(let i = 0; i < current.valores.length; i++) {
            if(current.valores[i].importe != null) {
                presupuestos.push({
                    idPresupuesto: current.valores[i].idPresupuesto,
                    categoriaPresupuesto: { idCategoriaPresupuesto: current.idCategoriaPresupuesto },
                    idEstancia: { idEstancia: current.idEstancia },
                    importe: current.valores[i].importe,
                    month: current.valores[i].month,
                    periodo: current.periodo
                });
            }
        }

        console.log(presupuestos);

        axios.post(process.env.REACT_APP_API_URL + `presupuestos`, presupuestos, prepareHeaders()).
        then(res => {
            console.log(res.data);
            getPresupuestos();
            setShowModalInversiones(false);
        }).
        catch(err => {
            console.log(err);            
            setShowModalInversiones(false);
        });

    };

    const abrirModal = (item, index) => {
        setEditingIndex(index);
        setFormState({ ...item });
        setShowModal(true);
    };

    const guardarCambios = (nuevoTotal) => {
        const nuevosGastos = [...expenses];
        nuevosGastos[editingIndex] = { ...formState, total: nuevoTotal };
        
        let current = nuevosGastos[editingIndex];
        console.log(current);

        let presupuestos = [];
        for(let i = 0; i < current.valores.length; i++) {
            if(current.valores[i].importe != null) {
                presupuestos.push({
                    idPresupuesto: current.valores[i].idPresupuesto,
                    categoriaPresupuesto: { idCategoriaPresupuesto: current.idCategoriaPresupuesto },
                    idEstancia: { idEstancia: current.idEstancia },
                    importe: current.valores[i].importe,
                    month: current.valores[i].month,
                    periodo: current.periodo
                });
            }
        }

        console.log(presupuestos);

        axios.post(process.env.REACT_APP_API_URL + `presupuestos`, presupuestos, prepareHeaders()).
        then(res => {
            console.log(res.data);
            getPresupuestos();
            setShowModal(false);
        }).
        catch(err => {
            console.log(err);            
            setShowModal(false);
        });
    };

    const handleSearch = (e) => {
    }

    const isSupervisor = () => {
        if(cookie.kUserSession == undefined || cookie.kUserSession == null){
            return false;
        }
        return cookie.kUserSession.data.rol_id == 1;
    }

    useEffect(() => {
        checkSession("expenses", props.history, cookie.kUserSession);
        getPresupuestos();
        getInversiones();
    }, []);

    useEffect(() => {
        getPresupuestos();
        getInversiones();
    }, 
    [year]);

    return (
        <>
            <Header history={props.history} />
            <section className={styles.body}>
                <Row>
                    <Col>
                        <History items={history} current={"Planificación"} history={props.history} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <section className={styles.content}>
                            <Row>
                                <Col>
                                    <h1 className={styles.title}>Planificación de Presupuestos e Inversiones, {year-1 + '/' + year}</h1>
                                </Col>
                                <Col md={12}>
                                    <Form.Group style={{marginBottom: "15px"}}>
                                        <Form.Label htmlFor="periodo" className={styles.label}>Periodo</Form.Label>
                                        <Form.Control id="periodo" className={"karanda-input"} value={year} onChange={(e) => {setYear(e.target.value); }} type="number"/>
                                    </Form.Group>                                
                                </Col>                                                    
                            </Row>                            

                            <section className={styles.actions}>
                                <Row>
                                    <Col>
                                        <h3 className={styles.title}>Presupuestos</h3>
                                    </Col>
                                </Row>                                
                                {
                                    loading ? <div style={{ marginTop: "15px", textAlign: "center" }}><img src={loadingBtn} height="50" /> </div> : (
                                        expenses.length == 0 ? (
                                            <div style={{ marginTop: "15px", textAlign: "center" }}><span>No hay categorias configuradas</span></div>
                                        ) : (
                                                isMobile() ? (<span>Vista no disponible</span>) : (
                                                        <>
                                                            <Table className="karanda-table" style={{ marginTop: "15px" }} hover>
                                                                <thead>
                                                                    <th>Categoría</th>
                                                                    <th>Julio</th>
                                                                    <th>Agosto</th>
                                                                    <th>Septiembre</th>
                                                                    <th>Octubre</th>
                                                                    <th>Noviembre</th>
                                                                    <th>Diciembre</th>
                                                                    <th>Enero</th>
                                                                    <th>Febrero</th>
                                                                    <th>Marzo</th>
                                                                    <th>Abril</th>                                                                                                                                        
                                                                    <th>Mayo</th>
                                                                    <th>Junio</th> 
                                                                    <th>TOTAL</th>                                                                                                                                     
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        expenses.map((expense, index) => {
                                                                            return (
                                                                                <tr key={index} style={{ cursor: "pointer" }} onClick={() => abrirModal(expense, index)}>
                                                                                    <td style={{textAlign: "left"}}>{expense.categoria}</td>
                                                                                    {
                                                                                        expense.valores.map((valor, idx) => (
                                                                                            <td style={{textAlign: "right"}}>{valor.importe ? `Gs. ${valor.importe.toLocaleString()}` : "-"}</td>
                                                                                        ))
                                                                                    }
                                                                                    <td style={{textAlign: "right", fontWeight: "bold"}}>Gs. {expense.total.toLocaleString()}</td>
                                                                                </tr>
                                                                            );
                                                                        })
                                                                    }
                                                                </tbody>
                                                                <tfoot>
                                                                    <th>TOTAL</th>
                                                                    {
                                                                        [0,1,2,3,4,5,6,7,8,9,10,11].map((mes, index) => (
                                                                            <th style={{textAlign: "right", fontWeight: "bold"}}>Gs. {getTotalPorMes(mes).toLocaleString()}</th>
                                                                        ))
                                                                    }
                                                                    <th style={{textAlign: "right", fontWeight: "bold"}}>Gs. {expenses.reduce((acc, e) => acc + e.total, 0).toLocaleString()}</th>                                                             
                                                                </tfoot>
                                                            </Table>
                                                        </>
                                                    )
                                            )
                                    )
                                }
                            </section>

                            <section className={styles.actions}>
                                <Row>
                                    <Col>
                                        <h3 className={styles.title}>Inversiones</h3>
                                    </Col>
                                </Row>                                
                                {
                                    inversionesLoading ? <div style={{ marginTop: "15px", textAlign: "center" }}><img src={loadingBtn} height="50" /> </div> : (
                                        inversiones.length == 0 ? (
                                            <div style={{ marginTop: "15px", textAlign: "center" }}><span>No hay categorias configuradas</span></div>
                                        ) : (
                                                isMobile() ? (<span>Vista no disponible</span>) : (
                                                        <>
                                                            <Table className="karanda-table" style={{ marginTop: "15px" }} hover>
                                                                <thead>
                                                                    <th>Categoría</th>
                                                                    <th>Julio</th>
                                                                    <th>Agosto</th>
                                                                    <th>Septiembre</th>
                                                                    <th>Octubre</th>
                                                                    <th>Noviembre</th>
                                                                    <th>Diciembre</th>
                                                                    <th>Enero</th>
                                                                    <th>Febrero</th>
                                                                    <th>Marzo</th>
                                                                    <th>Abril</th>                                                                                                                                        
                                                                    <th>Mayo</th>
                                                                    <th>Junio</th> 
                                                                    <th>TOTAL</th>                                                                                                                                     
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        inversiones.map((inversion, index) => {
                                                                            return (
                                                                                <tr key={index} style={{ cursor: "pointer" }} onClick={() => abrirModalInversinoes(inversion, index)}>                                                                                    
                                                                                    <td style={{textAlign: "left"}}>{inversion.categoria}</td>
                                                                                    {
                                                                                        inversion.valores.map((valor, idx) => (
                                                                                            <td style={{textAlign: "right"}}>{valor.importe ? `Gs. ${valor.importe.toLocaleString()}` : "-"}</td>
                                                                                        ))
                                                                                    }                                                                                    
                                                                                    <td style={{textAlign: "right", fontWeight: "bold"}}>Gs. {inversion.total.toLocaleString()}</td>
                                                                                </tr>
                                                                            );
                                                                        })
                                                                    }
                                                                </tbody>
                                                                <tfoot>
                                                                    <th>TOTAL</th>
                                                                    {
                                                                        [0,1,2,3,4,5,6,7,8,9,10,11].map((mes, index) => (
                                                                            <th style={{textAlign: "right", fontWeight: "bold"}}>Gs. {getTotalInversionesPorMes(mes).toLocaleString()}</th>
                                                                        ))
                                                                    }
                                                                    <th style={{textAlign: "right", fontWeight: "bold"}}>Gs. {inversiones.reduce((acc, e) => acc + e.total, 0).toLocaleString()}</th>                                                             
                                                                </tfoot>
                                                            </Table>
                                                        </>
                                                    )
                                            )
                                    )
                                }
                            </section>

                        </section>                    
                    </Col>
                </Row>
            </section>

            <ModificarLineaModal
                show={showModal}
                onClose={() => setShowModal(false)}
                formState={formState}
                setFormState={setFormState}
                onSave={guardarCambios}
            />            

            <ModificarInversionModal
                show={showModalInversiones}
                onClose={() => setShowModalInversiones(false)}
                formState={formStateInversiones}
                setFormState={setFormStateInversiones}
                onSave={guardarCambiosInversiones}
            />

        </>
    );

};

export default PresupuestosPlanificacion;